import { render, staticRenderFns } from "./GroupTypeProductList.vue?vue&type=template&id=66294ac8&scoped=true"
import script from "./GroupTypeProductList.vue?vue&type=script&lang=js"
export * from "./GroupTypeProductList.vue?vue&type=script&lang=js"
import style0 from "./GroupTypeProductList.vue?vue&type=style&index=0&id=66294ac8&prod&lang=scss"
import style1 from "./GroupTypeProductList.vue?vue&type=style&index=1&id=66294ac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66294ac8",
  null
  
)

export default component.exports